interface FloatingCardContentProps {
  top: React.ReactNode;
  center: React.ReactNode;
  bottom: React.ReactNode;
}

const FloatingCardContent: React.FC<React.PropsWithChildren<FloatingCardContentProps>> = ({
  top,
  center,
  bottom,
}) => {
  return (
    <div className="flex flex-col w-full">
      <div className="flex w-full justify-between px-5 items-center min-h-[3.5rem] lg:h-16">
        {top}
      </div>

      <hr className="hidden lg:block border-gray-200" />

      <div className="hidden lg:block p-4">{center}</div>

      <hr className="border-gray-200" />

      <div className="flex w-full p-3 lg:p-4 bg-white lg:rounded-b-md">{bottom}</div>
    </div>
  );
};

export default FloatingCardContent;
